import { TeachingLocation } from 'types/location'
import { authorizedGet } from '..'

export type ReadLocationProps = {
  id: string
}

export const readLocation = async ({
  id,
}: ReadLocationProps): Promise<TeachingLocation> => {
  try {
    const response = await authorizedGet({
      endpoint: `location/${id}`,
    })
    const { location } = (await response.json()) as {
      success: true
      location: TeachingLocation
    }
    return location
  } catch (e) {
    throw e
  }
}
